import { render, staticRenderFns } from "./UIMap.vue?vue&type=template&id=27576e9d&scoped=true&"
import script from "./UIMap.vue?vue&type=script&lang=ts&"
export * from "./UIMap.vue?vue&type=script&lang=ts&"
import style0 from "./UIMap.vue?vue&type=style&index=0&id=27576e9d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27576e9d",
  null
  
)

export default component.exports